import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoryConfig } from 'services/story.service';
import { StoryBoardTracks } from 'services/storyboard.service';
const SLICE_ID = 'editor-controls';

export const SB_POSITION = { track: StoryBoardTracks.storyBoard, cell: 0 };
export type SbPosition = { track: StoryBoardTracks; cell: CursorCell };

export type TitleCredits = {
  data: StoryConfig;
  key: 'title' | 'credits';
};

export interface State {
  sbPosition: SbPosition;
  recentlyMovedClips: Record<ClipId, true>;
  titleCredits: TitleCredits | null;
  backupModalListener: boolean;
}

const initialState: State = {
  backupModalListener: false,
  sbPosition: SB_POSITION,
  recentlyMovedClips: {},
  titleCredits: null,
};

// S L I C E

export const editorControlsSlice = createSlice({
  name: SLICE_ID,
  initialState,
  reducers: {
    setBackupModalListener: (state, action: PayloadAction<boolean>) => {
      state.backupModalListener = action.payload;
    },
    setSbPosition: (state, action: PayloadAction<SbPosition>) => {
      state.sbPosition = action.payload;
    },
    setTitleCredits: (state, action: PayloadAction<TitleCredits | null>) => {
      state.titleCredits = action.payload;
    },
    setRecentlyMovedClips: (state, action: PayloadAction<ClipId[]>) => {
      if (!action.payload.length) state.recentlyMovedClips = {};
      else {
        action.payload.forEach((clipId) => {
          state.recentlyMovedClips[clipId] = true;
        });
      }
    },
    resetEditorControls: () => {
      return initialState;
    },
  },
});

export const { setSbPosition, resetEditorControls, setRecentlyMovedClips, setTitleCredits, setBackupModalListener } =
  editorControlsSlice.actions;

export default editorControlsSlice.reducer;
